import React from 'react';
import { Wrench, Clock, AlertTriangle, LogIn } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const LOGO_URL = 'https://customer-assets.emergentagent.com/image_cache/cec3f5cc-8e65-4f62-9e13-ccee8a1b7e4e/logo-prysme-analytics-no-bg.png';

export const MaintenancePage = ({ maintenanceMode, onAdminAccess }) => {
  const formatDate = (dateString) => {
    if (!dateString) return null;
    try {
      return new Date(dateString).toLocaleString('fr-FR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg bg-card border-border">
        <CardContent className="p-8">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src={LOGO_URL} 
              alt="Prysm'Analytics" 
              className="w-24 h-24 object-contain"
            />
          </div>

          {/* Maintenance Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-orange-500/20 flex items-center justify-center">
              <Wrench className="w-10 h-10 text-orange-500 animate-pulse" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-heading font-bold text-foreground text-center mb-2">
            Maintenance en cours
          </h1>
          
          <p className="text-muted-foreground text-center mb-6">
            L'application est actuellement en maintenance. Veuillez réessayer ultérieurement.
          </p>

          {/* Reason */}
          {maintenanceMode?.reason && (
            <div className="bg-secondary/50 rounded-lg p-4 mb-4">
              <div className="flex items-start gap-3">
                <AlertTriangle className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Raison de la maintenance</p>
                  <p className="text-sm text-muted-foreground">{maintenanceMode.reason}</p>
                </div>
              </div>
            </div>
          )}

          {/* Estimated End */}
          {maintenanceMode?.estimated_end && (
            <div className="bg-secondary/50 rounded-lg p-4 mb-6">
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Fin estimée</p>
                  <p className="text-sm text-muted-foreground">
                    {formatDate(maintenanceMode.estimated_end)}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Admin Access Button */}
          <Button 
            variant="outline" 
            className="w-full border-border text-foreground hover:bg-secondary/50"
            onClick={onAdminAccess}
            data-testid="admin-access-btn"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Accès Administrateur
          </Button>

          {/* Footer */}
          <p className="text-xs text-muted-foreground text-center mt-6">
            Nous nous excusons pour la gêne occasionnée.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
